import MetricDisplay from '@/components/ui/MetricDisplay';
import { SingleMetrics } from '../home/DashboardPage';
import { DistributorReservationsTable } from '@/components/dashboard/ReservationsTables';
import { EstimateStatus } from '@/types/estimates/EstimateStatus';
import { useTranslation } from '@/i18n';

const DashboardPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 p-6 items-start grow bg-brand-25 h-full">
      <h1 className="text-[#0c111d] text-[32px] font-semibold font-['Geist'] leading-loose">
        {t('common.dashboard')}
      </h1>
      <CountMetrics />
      <div className="flex flex-1 flex-col md:flex-row gap-6 self-stretch">
        <div className="flex flex-1 flex-col gap-6">
          <MetricDisplay
            title={t('pages.dashboard.confirmedReservations')}
            subText={t('pages.dashboard.confirmedReservationsDescription')}
            childPosition="bottom"
          >
            <DistributorReservationsTable status={EstimateStatus.RESERVED} />
          </MetricDisplay>
          <MetricDisplay
            title={t('pages.dashboard.reservationRequests')}
            subText={t('pages.dashboard.reservationRequestsDescription')}
            childPosition="bottom"
          >
            <DistributorReservationsTable status={EstimateStatus.ESTIMATE} />
          </MetricDisplay>
          <MetricDisplay
            title={t('pages.dashboard.estimatesInProgress')}
            subText={t('pages.dashboard.estimatesInProgressDescription')}
            childPosition="bottom"
          >
            <DistributorReservationsTable status={EstimateStatus.PENDING} />
          </MetricDisplay>
        </div>
        <img
          src="/images/dashboard-illustration.jpg"
          className="sticky shrink-0 h-full top-20"
        />
      </div>
    </div>
  );
};

export default DashboardPage;

const CountMetrics = () => {
  return (
    <div className="grid grid-cols-1 [@media_(min-width:500px)]:grid-cols-2 [@media_(min-width:910px)]:grid-cols-4 gap-6 w-full">
      <SingleMetrics type="estimates" />
      <SingleMetrics type="clients" />
      <SingleMetrics type="shared-circuits" />
      <SingleMetrics type="receivers" />
    </div>
  );
};
